import React from 'react';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Chip from '@material-ui/core/Chip';
import useQueryParams from 'utils/useQueryParams';
import { TableHead } from '@material-ui/core';
import ProgressFullscreen from 'components/common/ProgressFullscreen';

const useStyles = makeStyles(theme => ({
  tableRoot: {
    marginTop: theme.spacing(1),
    width: 'unset'
  },
  cellRoot: {
    border: 0,
    padding: `0 ${theme.spacing(4)}px 0 0`,
    height: '40px'
  },
  cellName: {
    minWidth: '34em'
  },
  cellStatus: {
    minWidth: '10em'
  },
  chipRoot: {
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.grey[300]}`
  },
  radioGroupRoot: {
    display: 'block'
  },
  radioButtonRoot: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem'
    }
  },
  ppiLabelContainer: {
    userSelect: 'none'
  },
  borderProp: {
    borderBottom: 'none',
    padding: '15px 0px'
  }
}));

// row = {
//    id,
//    name,
//    status,
//    actions
// }
const PpsiTable = ({ rows = [], exclude, dataLoaded }) => {
  const [formulaCode, fromPpsiId, localPpsiCopy] = useQueryParams(
    'formulaCode',
    'fromPpsiId',
    'localPpsiCopy'
  );
  const classes = useStyles();
  const showExlcude =
    (formulaCode !== undefined && fromPpsiId !== undefined) ||
    (formulaCode !== undefined && localPpsiCopy === 'true');

  return (
    <Table classes={{ root: classes.tableRoot }}>
      {dataLoaded && <ProgressFullscreen />}
      <TableHead>
        <TableRow>
          <TableCell className={classes.borderProp}>iFood ID</TableCell>
          <TableCell className={classes.borderProp}>Product Name</TableCell>
          <TableCell className={classes.borderProp}>PIA Number</TableCell>
          <TableCell className={classes.borderProp} />
          <TableCell className={classes.borderProp} />
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(
          ({
            id,
            ifoodId,
            name,
            status,
            actions,
            globalIngredientId = '',
            piaNumber
          }) => {
            return (
              <>
                <TableRow key={id}>
                  <TableCell
                    classes={{ root: cx(classes.cellRoot) }}
                    key="ifoodId"
                  >
                    {ifoodId}
                  </TableCell>
                  <TableCell
                    classes={{ root: cx(classes.cellRoot) }}
                    key="name"
                  >
                    {name}
                  </TableCell>

                  <TableCell
                    classes={{ root: cx(classes.cellRoot) }}
                    key="piaNumber"
                  >
                    {piaNumber}
                  </TableCell>

                  <TableCell
                    classes={{ root: cx(classes.cellRoot, classes.cellStatus) }}
                    key="status"
                  >
                    {status && (
                      <Chip
                        label={status}
                        size="medium"
                        classes={{ root: classes.chipRoot }}
                      />
                    )}
                  </TableCell>
                  <TableCell classes={{ root: classes.cellRoot }} key="actions">
                    {actions}
                  </TableCell>
                </TableRow>
              </>
            );
          }
        )}
        {!showExlcude && <TableRow key={Date.now()}>{exclude}</TableRow>}
      </TableBody>
    </Table>
  );
};

export default PpsiTable;
